import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Directions
        </div>
        <div className="assessment1-content">
          Now that you have finalized the 6 guests’ orders, it’s time to enter their orders into a computer that sends that information to the kitchen.  There’s one problem. The screen of the machine is broken, meaning you’ll have to enter their orders by replicating the pattern of buttons (and associated sounds) that correspond to each meal. 
        </div>

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
